import React from 'react'

import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import { login } from '../../services/auth'
import * as Utils from './utils'
import { Loading } from '../../components/loading/component'
import './styles.scss'
import { Logo } from '../../components/images/logo'

interface LoginProps {
  loginSuccessCallback: any
}

export const Login = (props: LoginProps) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [errorMessage, setErrorMessage] = React.useState('')

  const handleLogin = (e) => {
    e.preventDefault()
    setErrorMessage('')
    setIsLoading(true)

    login(email, password)
      .then((payload) => {
        setIsLoading(false)
        if (payload.success === true) {
          props.loginSuccessCallback()
          return
        }

        setErrorMessage(payload.message)
      })
  }

  return <main className="main">
    <Logo />
    <section className="login-section">
      <div className="login-form-wrapper">
        <h1 className="h1">Login</h1>
        <Form className="login-form">
          <FormGroup className="login-form-row">
            <Label className="login-input-label">Email</Label>
            <Input
              className="login-form-control"
              name="email"
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              invalid={email.length > 0 && !Utils.validateEmail(email)}
              placeholder="johndoe@gmail.com" />
          </FormGroup>
          <FormGroup className="login-form-row">
            <Label htmlFor="password" className="login-input-label">Password</Label>
            <Input
              className="login-form-control"
              type="password"
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="password" />
          </FormGroup>
          {
            !isLoading && errorMessage &&
              <div className="validation-error">
                {errorMessage}
              </div>
          }
          {isLoading && <Loading size="64"></Loading>}
          <Button
            type="button"
            className="login-submit-btn"
            onClick={handleLogin}
            disabled={!email.length  || !password.length || isLoading}>
            Login
          </Button>
        </Form>
      </div>
    </section>
  </main>
}
